import API from "serviceshift-ui/api-client";

export interface Installment {
  id?: number;
  label: string;
  label_overridden?: boolean;
  value: number;
  calculated_opposite_value: number;
  amount_cents?: number;
  paid_at?: string | null;
  position: number;
  due_date?: string | null;
  _destroy?: boolean;
}

export interface JobPaymentSchedule {
  id: number;
  job_id: number;
  split_mode: "percentage" | "amount";
  status: "saved" | "locked";
  installments: Installment[];
}

export interface JobPaymentScheduleResponse {
  schedule: JobPaymentSchedule | null;
}

interface JobPaymentScheduleParams {
  split_mode: "percentage" | "amount";
  installments_attributes: Installment[];
  expected_balance_cents?: number;
}

function url(jobId: number): string {
  return `/v2/jobs/${jobId}/job_payment_schedule`;
}

export default {
  async fetchJobPaymentSchedule(
    _: unknown,
    jobId: number
  ): Promise<JobPaymentScheduleResponse | null> {
    try {
      const response = await API.makeRequest<JobPaymentScheduleResponse>(
        url(jobId),
        { headers: { ignoreError: true } }
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) return null;
      throw error;
    }
  },

  async createJobPaymentSchedule(
    _: unknown,
    { jobId, ...params }: { jobId: number } & JobPaymentScheduleParams
  ): Promise<JobPaymentScheduleResponse> {
    const response = await API.makeRequest<JobPaymentScheduleResponse>(
      url(jobId),
      {
        method: "POST",
        data: { job_payment_schedule: params },
        headers: { ignoreError: true }
      }
    );
    return response.data;
  },

  async updateJobPaymentSchedule(
    _: unknown,
    { jobId, ...params }: { jobId: number } & Partial<JobPaymentScheduleParams>
  ): Promise<JobPaymentScheduleResponse> {
    const response = await API.makeRequest<JobPaymentScheduleResponse>(
      url(jobId),
      {
        method: "PUT",
        data: { job_payment_schedule: params },
        headers: { ignoreError: true }
      }
    );
    return response.data;
  },

  async deleteJobPaymentSchedule(_: unknown, jobId: number): Promise<void> {
    await API.makeRequest(url(jobId), {
      method: "DELETE",
      headers: { ignoreError: true }
    });
  }
};
